import React, { useCallback, useState } from "react";
import classNames from "classnames";
import Parser, { domToReact } from "html-react-parser";
import CircleArrowDown from "../icons/circle-arrow-down.svg";
import CircleArrowUp from "../icons/circle-arrow-up.svg";
import { Link } from "./link";
import { graphql, useStaticQuery } from "gatsby";
import ScrollLink from "./scroll-link";
import { eventInternalLinkClick } from "../utility/datalayer";

const BannerFeaturesPdp = ({ data, position, pagePath }) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = useCallback(() => setOpen((value) => !value), []);

  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels {
        discoverMore
        checkDimensions
      }
    }
  `);

  const onClickFeaturePdp = useCallback(() => {
    eventInternalLinkClick({
      click_element: "pdp_rassurance",
      position: `pdp_${position}`,
      link_text: data?.linkText ? `pdp_${data?.linkText}` : null,
      action: !open ? "pdp_open" : "pdp_close",
      slug: pagePath,
    });
  }, [open, position, pagePath, data?.linkText]);

  return (
    <div
      className={classNames(
        `box-accordion${open ? " open" : ""} box-accordion--pdp box-accordion--pdp-${position}`,
        data?.customName && `box-accordion--pdp-${data.customName}`
      )}
    >
      <button
        className="box-accordion__title w-100 d-flex flex-row align-items-center"
        onClick={() => {
          toggleOpen();
          onClickFeaturePdp();
        }}
        disabled={!data?.abstract}
      >
        <span className="d-flex align-items-center text-left mr-1 text-sm-medium">
          <img className="icon-svg" src={data?.icon?.node?.publicURL} alt={data?.title || ""} />
          {data?.title}
        </span>
        <span className="mt-1 mt-md-0 d-flex align-items-center">
          <div className="box-accordion__button">
            <CircleArrowDown
              className={classNames("circle-arrow-down", !open ? "d-block ml-2" : "d-none")}
            />
            <CircleArrowUp
              className={classNames("circle-arrow-up", open ? "d-block ml-2" : "d-none")}
            />
          </div>
        </span>
      </button>
      {data?.abstract && (
        <div className="box-accordion__content">
          <div className="box-accordion__content-inner">
            {Parser(data.abstract, {
              replace: (node) => {
                if (node.name === "p" && !node.next) {
                  return (
                    <p>
                      {domToReact(node.children, {})}
                      {data?.link ? (
                        <>
                          <span> </span>
                          {data.link === "dimensions" ? (
                            <ScrollLink
                              href={`#technical-spec`}
                              className="product-detail__view-st ml-0"
                              onClick={() => {
                                const event = new CustomEvent("open-dimensions");
                                document.dispatchEvent(event);
                              }}
                            >
                              <span>{labelManagerLabels.checkDimensions}</span>
                            </ScrollLink>
                          ) : (
                            <Link className="product-detail__view-st" to={data.link}>
                              {labelManagerLabels.discoverMore}
                            </Link>
                          )}
                        </>
                      ) : null}
                    </p>
                  );
                }
              },
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default BannerFeaturesPdp;
